export default __webpack_public_path__ + "static/media/mobile.7aaa833e.png";